module.exports = __webpack_public_path__ + "img/balance.c6d290be.svg";